import Vue from "vue";
import Vuex from "vuex";
import customer from './modules/customer'
import authentication from './modules/authentication'
import storeManager from './modules/storeManager'
import tracking from './modules/tracking'
import bigPackage from './modules/bigPackage'
import feeWeight from './modules/feeWeight'
import feeVolume from './modules/feeVolume'
import configuration from './modules/configuration'
import notification from './modules/notification'
import customerLevel from './modules/customerLevel'
import staff from './modules/staff'
import payOrder from './modules/payOrder'
import paymentHistory from './modules/paymentHistory'
import specialFee from './modules/specialFee'
import commons from './modules/commons'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    customer,
    authentication,
    tracking,
    storeManager,
    bigPackage,
    feeWeight,
    feeVolume,
    configuration,
    notification,
    customerLevel,
    staff,
    payOrder,
    paymentHistory,
    specialFee,
    commons
  },
  state: {},
  mutations: {},
  actions: {},
  strict: false,
  plugins: [createPersistedState({paths:['authentication', 'commons', 'roles'], storage: window.localStorage})]
});
